var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButtonRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49971 0C9.57041 0 11.446 0.839649 12.803 2.19668C14.1601 3.55371 15 5.429 15 7.5C15 9.5707 14.1601 11.446 12.803 12.803C11.446 14.1601 9.57041 15 7.49971 15C5.429 15 3.55371 14.1601 2.19668 12.803C0.839649 11.446 0 9.5707 0 7.5C0 5.42959 0.839649 3.55371 2.19668 2.19668C3.55371 0.839649 5.429 0 7.49971 0ZM9.76729 7.90459C10.1701 7.64443 10.1687 7.35469 9.76729 7.12441L6.53672 4.87529C6.20889 4.66904 5.86611 4.79033 5.8752 5.21865L5.88809 9.74414C5.91621 10.2088 6.18164 10.3362 6.57275 10.1212L9.76729 7.90459ZM12.092 2.90771C10.9172 1.73291 9.29297 1.00576 7.49971 1.00576C5.70645 1.00576 4.08281 1.73291 2.90771 2.90771C1.73291 4.08281 1.00576 5.70674 1.00576 7.5C1.00576 9.29355 1.73291 10.9172 2.90771 12.092C4.08281 13.2671 5.70645 13.9942 7.49971 13.9942C9.29297 13.9942 10.9172 13.2671 12.092 12.092C13.2671 10.9172 13.9942 9.29355 13.9942 7.5C13.9942 5.70645 13.2671 4.08281 12.092 2.90771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonRoundIcon);
export default __webpack_public_path__ + "static/media/play-button-round-icon.145c011d6b58a22786b9f8958bd0584b.svg";
export { ForwardRef as ReactComponent };